import React from "react";
import { UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { ManageMultipleFilesModal } from "./ManageMultipleFilesModal";

interface Props {
  flightPassengerId: number
  isOpen: boolean
  onClose: () => void
  canEdit: boolean

  files: server.dto.File[]
  onFilesChanged: () => Promise<void>
}

export const ManageFlightPassengerFilesModal = (props: Props) => {
  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.Flight.UploadPassengerFiles,
      window.CoreApi.Flight.UploadPassengerFiles.absoluteUrl(),
      {
        files,
        flightPassengerId: props.flightPassengerId
      },
      uploadConfig
    );
  };

  return <ManageMultipleFilesModal
    {...props}
    upload={uploadFiles}
    deleteEndpoint={(id: number) => window.CoreApi.Flight.DeletePassengerFile({
      flightPassengerFileId: id
    })}
    renameEndpoint={(file: server.dto.File) => window.CoreApi.Flight.UpdatePassengerFileName({
      flightPassengerFileId: file.id,
      fileName: file.name
    })}
  />
}